// SEO.tsx
import * as React from 'react';
import { MetaTag, Meta } from '../services/SEOServiceProvider';
import logoBlackTp from '../assets/img/logo_black_tp.png';

export function SEO({ metaTag }: { metaTag: MetaTag | undefined }) {

    return metaTag === undefined ? (
        <> </>
    ) : (
        <article>
            { /* Standard metadata tags */ }
            <title>{metaTag.title}</title>
            <meta name='description' content={metaTag.description} />
            <meta name='title' content={metaTag.title} />
            <meta name='keywords' content={metaTag.keywords} />
            { /* End standard metadata tags */ }
            { /* Google tags */ }
            <meta itemProp='name' content={metaTag.title} />
            <meta itemProp='description' content={metaTag.description} />
            <meta itemProp='image' content={metaTag.image || logoBlackTp} />
            { /* End Google tags */ }
            { /* Facebook tags */ }
            <meta property='og:type' content={metaTag.type} />
            <meta property='og:title' content={metaTag.title} />
            <meta property='og:description' content={metaTag.description} />
            <meta property='og:url' content={metaTag.url} />
            <meta property='og:image' content={metaTag.image || logoBlackTp} />
            <meta property='og:site_name' content={metaTag.title.split('|')[0].trim()} />
            { /* End Facebook tags */ }
            { /* Twitter tags */ }
            <meta name='twitter:creator' content={metaTag.title.split('|')[0].trim()} />
            <meta name='twitter:card' content={metaTag.type} />
            <meta name='twitter:title' content={metaTag.title} />
            <meta name='twitter:description' content={metaTag.description} />
            <meta name='twitter:url' content={metaTag.url} />
            <meta name='twitter:image' content={metaTag.image || logoBlackTp} />
            { /* End Twitter tags */ }
            { /* Custom meta tags */ }
            {metaTag.metas.map((item: Meta) => (
                <meta name={item.key} content={item.value} />
            ))}
            { /* End Custom meta tags */ }

            <meta name='robots' content='index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' />
            <meta httpEquiv='Content-Type' content='text/html; charset=utf-8' />
            <meta name='language' content='English' />
            <meta name='revisit-after' content='7 days' />
            <meta name='author' content='OBOSS / eiNjel' />
            <meta name='googlebot-news' content='index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' />

            <link rel='canonical' href={metaTag.url} />
        </article>
    );
}
